export const CERT_EXPORT_CHUNK_SIZE = 50;

export const formatBytes = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const parseContentDispositionFileName = (headerValue = "") => {
  const utfMatch = String(headerValue).match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch?.[1]) {
    try {
      return decodeURIComponent(utfMatch[1]);
    } catch {
      return utfMatch[1];
    }
  }
  const basicMatch = String(headerValue).match(/filename="([^"]+)"/i);
  if (basicMatch?.[1]) return basicMatch[1];
  return "";
};

export const triggerBlobDownload = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};

export const parseExportErrorMessage = async (err, fallback = "Không thể tải file.") => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const j = JSON.parse(text);
      if (j?.message) return j.message;
    } catch {
      /* keep fallback */
    }
  } else if (typeof data?.message === "string") {
    return data.message;
  }
  if (err?.message) return err.message;
  return fallback;
};

export const chunkArray = (items, size = CERT_EXPORT_CHUNK_SIZE) => {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};
